module.exports = __webpack_public_path__ + "img/phone-watch.eace0861.png";